<template>
  <v-icon
    v-if="value === true"
    color="green"
    size="20"
    :title="trans('general.yes')"
  >
    mdi-checkbox-marked-outline
  </v-icon>
  <v-icon
    v-else
    color="error lighten-2"
    size="20"
    :title="trans('general.no')"
  >
    mdi-close-box-outline
  </v-icon>
</template>

<script>
import {LocaleUtils} from '../utils/locale-utils'

export default {
  name: 'boolean-flag-icon',
  mixins: [
    LocaleUtils
  ],
  props: {
    value: {
      type: Boolean,
      required: true
    }
  }
}
</script>
